import { gql } from './__generated__/gql';

export const ASSESSMENT_QUERY = gql(`
    query Assessment($assessmentUid: String!) {
        assessment(assessmentUid: $assessmentUid) {
        uid
        isLocked
        name
        contextText
        introText
        preQuestionText
        questions {
            uid
            text
            questionType
            ordinal
            isOptional
            isSensitive
            answers {
            uid
            text
            }
            conditions {
            dependsOnQuestion {
                uid
                questionType
                ordinal
            }
            dependsOnAnswer {
                uid
            }
            isNegated
            }
        }
        }
    }
  `);

export const ME_QUERY = gql(`
    query Me {
        me {
            accountType
            phone
        }
    }
`);

export const ASSESSMENTS_QUERY = gql(`
    query($pdtUid: String) {
        assessments(pdtUid: $pdtUid) {
            uid,
            name,
        }
    }
`);

export const ASSIGNMENTS_QUERY = gql(`
query Assignments($pdtUid: String, $onlyVisible: Boolean!, $clientType: String!) {
    assignments(onlyVisible: $onlyVisible, clientType: $clientType, pdtUid: $pdtUid) {
        uid,
        pdt {
            uid,
            name
        },
        assessment {
            name,
            uid
        },
        dueDate,
        typeOfAssignment,
        completeTime,
        canSkipQuestions,
        aboutUser {
            firstName,
            language
        }
    }
}
`);

export const CHECK_ELIGIBILITY_QUERY = gql(`
    query eligibilityStatus(
        $pdtUid: String!, 
        $firstName: String!, 
        $lastName: String!,
        $dateOfBirth: Date!,
        $postalCode: String,
        $organizationSlug: String!,
        $productId: Int!,
        $employeeId: String,
        $uid: String,
        $utmSource: String,
        $utmMedium: String,
        $utmCampaign: String,
        $utmTerm: String,
        $utmContent: String,
        $utmId: String,
        $utmCampaignDate: String,
        ) {
            eligibilityStatus(
                pdtUid: $pdtUid,
                firstName: $firstName,
                lastName: $lastName,
                dateOfBirth: $dateOfBirth,
                postalCode: $postalCode,
                organizationSlug: $organizationSlug,
                productId: $productId,
                employeeId: $employeeId,
                uid: $uid,
                utmSource: $utmSource,
                utmMedium: $utmMedium,
                utmCampaign: $utmCampaign,
                utmTerm: $utmTerm,
                utmContent: $utmContent,
                utmId: $utmId,
                utmCampaignDate: $utmCampaignDate,
            ) {
                isEligible
            }
        }
`);

export const ELIGIBILITY_CONFIGURATION_QUERY = gql(`
    query eligibilityConfiguration($organizationSlug: String!, $pdtUid: String!) {
        eligibilityConfiguration(organizationSlug: $organizationSlug, pdtUid: $pdtUid) {
            isValid,
            collectZipcodeForEligibility,
            hasEmployeeId,
            hasAddressField,
            employeeIdFieldRename,
            isGeneric,
            employeeIdValidationEnabled,
            employeeIdAllowedChars,
            employeeIdMinLength,
            employeeIdMaxLength,
            employeeIdValidationErrorMessage,
            employeeIdExample
        }
    }
`);

export const QUERY_DISTINCT_ID_WITH_EMAIL = gql(`
    query posthogDistinctIdWithEmail($email: String!) {
        posthogDistinctIdWithEmail(email: $email) {
            distinctId
            userUid
        }
    }
`);

export const QUERY_ALL_POSTHOG_FEATURE_FLAGS = gql(`
    query posthogFeatureFlags {
        allFeatureFlags {
            values
        }
    }
`);

export const QUERY_POSTHOG_FEATURE_FLAG = gql(`
    query posthogFeatureFlag($email: String!, $featureFlagName: String!) {
        featureFlag(email: $email, featureFlagName: $featureFlagName){
            value
        }
    }
`);

export const QUERY_ORGANIZATION_BY_SLUG = gql(`
    query organizationName($organizationSlug: String!) {
        organizationName(organizationSlug: $organizationSlug) {
            name
        }
    }
`);

export const ORGANIZATIONS_BY_PREFIX_QUERY = gql(`
    query organizationsByPrefix($prefix: String!, $limit: Int!, $searchFilters: JSONString!) {
        organizationsByPrefix(prefix: $prefix, limit: $limit, searchFilters: $searchFilters) {
            name
            slug
        }
    }
`);
